module.exports = __webpack_public_path__ + "media/src/images/icons/FN_name_logo-81fddb5f2cf8f910da70b9824358ee6f.svg";